/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "../contactResponseDtoSchema";
import { updateContactDtoSchema } from "../updateContactDtoSchema";
import { z } from "zod/v4";

export const updateContactPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const updateContactHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Update contact
 */
export const updateContact200Schema = z.lazy(() => contactResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const updateContact401Schema = z.any()

export const updateContactMutationRequestSchema = z.lazy(() => updateContactDtoSchema)

export const updateContactMutationResponseSchema = z.lazy(() => updateContact200Schema)